/* eslint no-param-reassign: "error" */

export default {
  ADD_CHANGED_PAYMENT_LEASE_RATE(state, data) {
    const i = state.leaseRateChangeEventPaymentIds.findIndex(elem => elem.paymentParametersId === data.paymentParametersId);
    if (i !== -1) {
      state.leaseRateChangeEventPaymentIds[i] = data;
    } else {
      state.leaseRateChangeEventPaymentIds.push(data);
    }
  },
  DELETE_ALL_CHANGED_PAYMENT_LEASE_RATE(state) {
    state.leaseRateChangeEventPaymentIds = [];
  },
  ADD_NOT_CHANGE_PAYMENT(state, data) {
    if (!state.notChangesEventPaymentIds.includes(data)) {
      state.notChangesEventPaymentIds.push(data);
    }
  },
  DELETE_NOT_CHANGE_PAYMENT(state, data) {
    state.notChangesEventPaymentIds.forEach((elem, i) => {
      if (elem === data) {
        state.notChangesEventPaymentIds.splice(i, 1);
      }
    });
  },
  DELETE_ALL_CHANGE_PAYMENT(state) {
    state.notChangesEventPaymentIds = [];
  },

  SET_CONTRACT_ASSET_COMPONENTS(state, data) {
    state.contractAssetComponents = data
  }
};
